import type {SocialMediaProfileLinksMap} from '@Components/social-media-profile-links/social-media-profile-links.types';

export const organiserImgTypeDropdownID = 'organiserImgTypeDropdownID';

export interface EventWizardOrganisersProps {
  organisersDetails: OrganiserDetails[];
  onClickOption: (option: OrganiserDetails) => void;
}

export interface EventWizardOrganisers {
  allOrganisers: OrganiserDetails[];
  selectedOrganiser: OrganiserDetails;
}

export interface OrganiserDetails {
  hashedId?: string;
  name: string;
  email: string;
  phone?: string;
  profilePic: string;
  isProfilePicturePrefilled: boolean;
  socialMediaLinks: SocialMediaProfileLinksMap;
  isFromBusinessProfile?: boolean;
}
